import moment from "moment";

/**
 * ¿La factura está vencida? (su fecha de emisión es más antigua que `diasMaximo` días).
 *
 * Compara strings YYYY-MM-DD (no Dates), igual que el original BeforeFacture.vue:date_emision.
 * El parámetro `hoy` es inyectable para tests deterministas.
 */
export function isFacturaVencida(
	fechaEmision: string,
	diasMaximo: number,
	hoy: Date = new Date()
): boolean {
	if (!fechaEmision) {
		return false;
	}
	const limite = moment(hoy).subtract(diasMaximo, "d").format("YYYY-MM-DD");
	const emision = moment(fechaEmision.trim(), "YYYY-MM-DD").format("YYYY-MM-DD");
	return limite > emision;
}

/**
 * NOTA sobre estado de onboarding:
 *
 * El método `valestado(v)` en BeforeFacture.vue se quedó con la semántica de
 * "siempre permite" (devuelve false en cualquier rama) tras el revert del fix
 * que rompía el paso 3. Esto es intencional hasta confirmar con producto qué
 * estados deberían realmente bloquear acciones.
 *
 * Cuando esa decisión exista, agregar acá la función pura con la regla
 * correcta y reemplazar `valestado` en el componente. Mientras tanto, NO se
 * expone una función `estadoOnboardingValido` para evitar reintroducir el bug.
 */
